import { apiRequest } from "../apiServices";

export const getPincodeMaster = async (pincode) => {
  if (!pincode || pincode.length < 6) return null;

  const payload = { pincode };

  const result = await apiRequest({
    portal: "dmq",
    method: "post",
    endpoint: "/pincode",
    data: payload,
  });

  console.log("result in service get pincode master", result);

  return result?.data?.body ?? null;
};
